import { defineMessages } from 'react-intl';

export const i18n: {
	confluenceFilterLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterSpacePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	space: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	space: {
		id: 'dynamic-cards-search-page.filters.names.space',
		defaultMessage: 'Space',
		description:
			'Label for space filter dropdown shown in search page filters where user can select space to filter search result by space',
	},
	confluenceFilterSpacePlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.space.placeholder',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for space filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'dynamic-cards-search-page.confluence.filter.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
